import { CommonModule } from '@angular/common';
import { AccountLibraryStoreEffects } from './account-library.effects';
import { EffectsModule } from '@ngrx/effects';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { accountLibraryReducer } from './account-library.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('account-library', accountLibraryReducer),
    EffectsModule.forFeature([AccountLibraryStoreEffects]),
  ],
  providers: [AccountLibraryStoreEffects],
})
export class AccountLibraryStoreModule {}
